import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { XCircle, House, ArrowRight } from "@phosphor-icons/react";
import Logo from "../components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F4F3ED] text-[#0A0A0A] flex flex-col">
      <header className="border-b border-[#D4D0C5] px-5 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <Logo className="h-10 w-auto" />
          <span className="font-display font-black text-sm tracking-tight">
            GREAT EAGLE TECH
          </span>
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="max-w-lg w-full border border-[#0A0A0A] p-8 lg:p-12" data-testid="payment-cancel">
          <XCircle size={56} weight="duotone" className="text-[#D9381E] mb-5" />
          <h1 className="font-display font-black text-3xl lg:text-4xl tracking-tighter mb-3">
            Payment cancelled.
          </h1>
          <p className="font-body text-[#4A4A4A] mb-7">
            No charge was made. You can return to the enrollment section and
            try again whenever you're ready — your seat isn't lost.
          </p>
          <button
            onClick={() => navigate("/#enroll")}
            data-testid="back-to-enroll"
            className="inline-flex items-center gap-2 bg-[#0A0A0A] text-[#F4F3ED] px-5 py-3 font-body text-sm uppercase tracking-[0.22em] hover:bg-[#D9381E] transition-colors"
          >
            <House size={14} /> Back to enrollment <ArrowRight size={14} weight="bold" />
          </button>
        </div>
      </main>
    </div>
  );
}
